import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setFilter({ commit }, data) {
    commit(types.SET_FILTER, data)
  },
  setList({ commit }, data) {
    commit(types.SET_LIST, data)
  },
  resetLists({ commit }) {
    commit(types.RESET_LISTS)
  },
  setSummary({ commit }, data) {
    commit(types.SET_SUMMARY, data)
  },
  setWeek({ commit }, data) {
    commit(types.SET_WEEK, data)
  },
  resetWeek({ commit }, data) {
    commit(types.RESET_WEEK, data)
  },
  resetSelectedView({ commit }) {
    commit(types.RESET_SELECTED_VIEW)
  },
  setSelectedView({ commit }, data) {
    commit(types.SET_SELECTED_VIEW, data)
  },
  setCustomColumn({ commit }, data) {
    commit(types.SET_CUSTOM_COLUMN, data)
  },
  updateCustomView({ commit }, data) {
    commit(types.UPDATE_CUSTOM_VIEW, data)
  },
  setMemberData({ commit }, data) {
    commit(types.SET_MEMBER_DATA, data)
  },
  setLibraryName({ commit }, data) {
    commit(types.SET_LIBRARYNAME, data)
  },
  setChallengeName({ commit }, data) {
    commit(types.SET_CHALLENGENAME, data)
  },
  setDashboardName({ commit }, data) {
    commit(types.SET_DASHBOARDNAME, data)
  },
  updateMemberData({ commit }, data) {
    commit(types.UPDATE_MEMBER_DATA, data)
  },
  setMemberForEmail({ commit }, data) {
    commit(types.SET_MEMBERIDS, data)
  },
  setUnreadMessages({ commit }, data) {
    commit(types.SET_UNREAD_MESSAGES, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  setCheckedInList({ commit }) {
    commit(types.SET_CHECKED_INLIST)
  },
  setMemberIdsDirect({ commit }, data) {
    commit(types.SET_MEMBERIDS_DIRECT, data)
  },
  setMembers({ commit }, data) {
    commit(types.SET_MEMBERIDS, data)
  },
  setMemberDailyProgressData({ commit }, data) {
    commit(types.SET_MEMBER_DAILYPROGRESS_DATA, data)
  },
  async getCustomViews({ commit }) {
    const r = await http.get(`v2/users/getpreference/CustomViews`)
    commit(types.SET_CUSTOM_VIEWS, r.data.data)
    return r.data.data
  },
  async saveCustomViews({ commit }, data) {
    const r = await http.post(`v2/users/savepreference`, data)
    return r.data
  },
  async getCustomViewsConfig({ commit }, data) {
    const r = await http.get(`v2/settings/getSetting`, {
      params: data,
    })
    commit(types.SET_CUSTOM_VIEWS_CONFIG, r.data.data)
    return r.data.data
  },
  async saveCustomViewsConfig({ commit }, data) {
    const r = await http.post(`v2/settings/saveSetting`, data)
    return r.data
  },
  async applyCustomViews({ commit }, data) {
    const r = await http.post(`v2/settings/applyCustomViews`, data)
    return r.data
  },
  async getMembers({ commit }, options) {
    if (options.forEmail === 0) {
      commit(types.SET_MEMBERS, null)
    }
    const r = await http.get(`v2/usercardio/members`, {
      params: options,
    })
    if (options.forEmail === 1) {
      commit(types.SET_MEMBERIDS, r.data.data)
    } else {
      commit(types.SET_MEMBERS, r.data.data)
    }
    return r.data.data
  },
  async getMember({ commit }, data) {
    const r = await http.get(`v2/usercardio/member`, {
      params: data,
    })
    commit(types.SET_MEMBER, r.data.data)
    return r.data.data
  },
  async getMemberGoals({ commit }, data) {
    const r = await http.get(`v2/usercardio/memberGoals`, {
      params: data,
    })
    commit(types.SET_MEMBER_GOALS, r.data.data)
    return r.data.data
  },
  async getMemberDailyProgress({ commit }, data) {
    const r = await http.get(`v2/usercardio/memberDailyProgress`, {
      params: data,
    })
    commit(types.SET_MEMBER_DAILYPROGRESS, r.data.data)
    return r.data.data
  },
  async getMemberProfileHistory({ commit }, data) {
    const r = await http.get(`v2/usercardio/memberProfileHistory`, {
      params: data,
    })
    commit(types.SET_MEMBER_PROFILEHISTORY, r.data.data)
    return r.data.data
  },
  async getLists({ commit }, orgid) {
    const r = await http.get(`v2/usercardio/lists/${orgid}`)
    commit(types.SET_LISTS, r.data.data)
    return r.data.data
  },
  async saveList({ commit }, data) {
    const r = await http.post(`v2/usercardio/list`, data)
    return r.data
  },
  async removeList({ commit }, id) {
    const r = await http.delete(`v2/usercardio/list/${id}`)
    return r.data
  },
  async getMemberSessionHeartRates({ commit }, data) {
    const r = await http.get(`v2/usercardio/memberSessionHeartrates`, {
      params: data,
    })
    commit(types.SET_MEMBER_SESSION_HEARTRATES, r.data.data)
    return r.data.data
  },
  async getMemberSessionDetail({ commit }, data) {
    const r = await http.get(`v2/usercardio/memberSessionDetail`, {
      params: data,
    })
    commit(types.SET_MEMBER_SESSION_DETAIL, r.data.data)
    return r.data.data
  },
  async getZoneProfile({ commit }, data) {
    const r = await http.get(`v2/usercardioprograms/zoneProfile`, {
      params: data,
    })
    commit(types.SET_ZONE_PROFILE, r.data.data)
    return r.data.data
  },
  async saveCardioZone({ commit }, data) {
    const r = await http.post(`v2/usercardioprograms/zoneProfile`, data)
    commit(types.SET_ZONE_PROFILE_HISTORY, r.data.data)
    return r.data
  },
  async removeCardioZone({ commit }, data) {
    const r = await http.delete(`v2/usercardioprograms/zoneProfile`, {
      params: data,
    })
    commit(types.REMOVE_PROFILE_HISTORY, r.data.data)
    return r.data
  },
  // usercardio/setstarlevel
  async setStarLevel({ commit }, data) {
    const r = await http.post(`v2/usercardio/setstarlevel`, data)
    commit(types.SET_STARLEVEL, data)
    return r.data
  },
  async getChallengeStats({ commit }, data) {
    const r = await http.get(`v2/challenges/liveprofilechallengestats`, {
      params: data,
    })
    commit(types.SET_CHALLENGE_STATS, r.data.data)
    return r.data.data
  },
  async recalcChallengeProgress({ commit }, data) {
    const r = await http.post(
      `v2/usercardio/recalculatechallengeprogress`,
      data
    )
    return r.data
  },
  async createMemberSession({ commit }, data) {
    const r = await http.post(`v2/usercardio/createMemberSession`, data)
    return r.data.data
  },
  async removeMemberSessions({ commit }, data) {
    const r = await http.post(`v2/usercardio/removeMemberSessions`, data)
    return r.data.data
  },
}
